<form class="container" [formGroup]="passwordChangeForm">
  <p class="subtitle has-text-info mb-4">{{ 'password-change.info' | translate }}</p>
  <hr>

  @if (passwordChangeForm.contains('oldPassword') && requestOld) {
  <div class="mb-4">
    <p class="mb-2">{{ 'password-change.old-password' | translate }}</p>
    <input [ngClass]="{'is-danger': (passwordChangeForm.get('oldPassword')?.invalid && passwordChangeForm.get('oldPassword')?.touched) || passwordChangeForm.get('oldPassword')?.hasError('wrongPassword') }"
           formControlName="oldPassword"
           class="input"
           type="password"
           placeholder="{{ 'password-change.old-password' | translate }}">
  </div>
  }

  <div class="mb-4">
    <p class="mb-2">{{ 'password-change.new-password' | translate }}</p>
    <input [ngClass]="{'is-danger': passwordChangeForm.get('newPassword')?.invalid && passwordChangeForm.get('newPassword')?.dirty}"
           formControlName="newPassword"
           class="input"
           type="password"
           placeholder="{{ 'password-change.new-password' | translate }}">
    <span class="subtext">
      {{ ('settings.security.password.new.text') | translate }}
    </span>
  </div>

  <div class="mb-4">
    <p class="mb-2">{{ 'password-change.confirm-password' | translate }}</p>
    <div class="control has-icons-right">
      <input [ngClass]="{'is-danger': passwordChangeForm.hasError('passwordMismatch') && passwordChangeForm.get('confirmPassword')?.dirty}"
             formControlName="confirmPassword"
             class="input"
             type="password"
             placeholder="{{ 'password-change.confirm-password' | translate }}">
      @if (passwordChangeForm.hasError('passwordMismatch')) {
      <span class="icon is-small is-right">
        <i class="fas fa-exclamation-triangle"></i>
      </span>
      }
    </div>
    @if (passwordChangeForm.hasError('passwordMismatch') && passwordChangeForm.get('confirmPassword')?.dirty) {
    <p class="help is-danger mt-1">{{ 'password-change.confirm-failed' | translate }}</p>
    }
  </div>

  <div class="mb-4">
    <span class="subtext mb-2 has-text-weight-semibold">
      {{ ('settings.security.password.strength.text') | translate }} : {{ ('settings.security.password.strength.' + passwordStatus) | translate }}
    </span>
    <progress class="progress" [ngClass]="progressColor" [value]="progressValue" max="100"></progress>
  </div>

  <button class="button is-primary is-fullwidth" (click)="validate()" [disabled]="passwordChangeForm.invalid || strengthScore < 3">{{ 'password-change.validate' | translate }}</button>
</form>
